import css from 'styled-jsx/css'

import { colors, fontWeights } from "app/theme";

export default css`
  .action-message{
    margin: 0.5rem 0;
  }

  .telephone{
    background-color: ${colors.lightGray};
    font-weight: ${fontWeights.semiBold};
    color:${colors.text};
    padding: 0.4rem;
    margin: 0;
  }
`
